export default __webpack_public_path__ + "baaf2486838edebdc52e13f3a06e6348.png";